import { composeIdentityApiActions } from '@bp/shared-domains-identity';

import type { Identity } from '../models';

export const IDENTITY_API_ACTIONS = composeIdentityApiActions<Identity>();
